const filesContext = require.context('./Tables', false, /\.js$/);
const files = filesContext.keys();
const {
    userColumns,
    robotColumns,
    phoneColumns,
    vpnColumns,
    ticketsDockerColumns,
    captchaColumns,
    messageColumns,
    accountColumns,
    taskColumns
} = files.reduce((acc, filePath) => {
    const fileKey = filePath.replace('./', '').replace('.js', ''); // 获取文件名作为键名
    const fileContent = filesContext(filePath).default; // 获取文件的默认导出内容
    return { ...acc, [fileKey]: fileContent };
}, {});

//表格各列配置
// {
//     title: 显示文本,
//     type:数据类型,
//     dataIndex: 数据对应的属性,
//     key: react的Key,
//     width: 固定宽度,
//     sorter: 排序函数,
//     defaultSortOrder: 顺序,
//     editable: 可编辑
// }
export const columnsList = [
    {
        bucket: 'bucket-users',
        columns: userColumns,
        type: 'multi'
    },
    {
        bucket: 'bucket-robots',
        columns: robotColumns,
        type: 'multi'
    },
    {
        bucket: 'bucket-tickets-docker',
        columns: ticketsDockerColumns,
        type: 'multi'
    },
    {
        bucket: 'phonelist',
        columns: phoneColumns,
        type: 'single'
    },
    {
        bucket: 'vpnlist',
        columns: vpnColumns,
        type: 'single'
    },
    {
        bucket: 'captchapass',
        columns: captchaColumns,
        type: 'single'
    },
    {
        bucket: 'bucket-message',
        columns: messageColumns,
        type: 'multi'
    },
    {
        bucket: 'bucket-accounts',
        columns: accountColumns,
        type: 'multi'
    },
    {
        bucket: 'bucket-task',
        columns: taskColumns,
        type: 'multi'
    },
]
